import { format } from "date-fns";
import { fr, enUS } from "date-fns/locale";

export enum UserRoleName {
  USER = 'USER',
  ADMIN='ADMIN',
}

export const userMenus: { name: string, route: string, icon: string, show?: boolean }[] = [
  { name: "Tableau de bord", route: "/dashboard", icon: "bx bx-home-alt", show: true },
  { name: "Utilisateurs Système", route: "/dashboard/system-users", icon: "users", show: true }
]

export const SSID = "104773056590-mvedvfdqopcc07h14llstuhp6pt070e6.apps.googleusercontent.com";
export const APIKEY = "da112348-fb56-4c12-b921-9a332104cd21";
export const jwtTokenIdentifier = "sapp-trad-pro-dashYDUWCw_LMus8UcgSjIlqfUZqmSZBxBbYwaZAOXQGwQHey9gAg7Mx5_xB35rdn2C5ae9tM6YdUwiAocGaQF9d6ALfGRwii7DdJgwrRhYpcFb1n28_9plkUfEIviWG6ZdFJJbx9WtyMU6pHse115UNuk6wWuiRtFgLAFJ_eu9Zimc0FWdgHggs8lqpqZlrgAAH2fmoWskq_FQp_g2VZFIxB3PaDZo6CqfCxjwyUJOiMP7FpaTsiTuPudgprTCCbIclGMWfGVJDXeWAnZj1DU1HgraLypvZJfJIinLIvERWgrT0Y8cYfqb3Zg7uO3eDmKApCtUfrl6nBdJenAQ7xLTP"
export const userIdentifier = "sapp-trad-pro-dash7WZEZG88a7S0Dbc3U0vy3ZcyscqdyxmRpv25vKw1tykdemtIpt1635i3MLBerB5TiDHHI-mJ6WePYuRiKeLMI2F4E4iG2wsqIpa6rvrgAz4qWuxlv8_myV97dvv3RYgFyK-uTDrKjowYvSGTmZ576TheM22TdvuXCuRo5dOcPCZcuZ9AwXUjRaRdt7PcXeBbfds"
export const otpTokenIdentifier = "sapp-trad-pro-dashz3mMTKcTdoVBcMbfz32xkmDIqVOBUyjW8pKu6Bl9evSBR8X3XmSvDyQkLfea1UgUEHRMAEqa1u8ob5pCWzM4hV1o2atgaTphtT8MHWSAg7MxcAUJIkEmevcfcAMk8OoEXRVdPt988mZRKaM3ucaIrqbHThSh09zKCwT579sk8KM3tWwShORJZGT0XrQqHirveamWgKSuw4rfocIW4QoqttVywqMBW2uRxv7mUHx1HWrGopjzD5O1MXApLF4Z73Fi"
export const authTokenIdentifier = "sapp-trad-pro-dash9uz1o1aWbYHFXpOTK3VZ2mKwcO62JV3Fr8D1v4MTzQxBvulvDu9lW9IZC63qUL67r4lhfKx5Ag7Mxgdroxl9E8WG9MlJzp1cwYB3dkVlpEY5pGWH9EiLY2Upxul98syoyEK7U3kXiGhBswF2DoDEoYyY9lS9PcWalbvDuP6SHJTCwGxSdIFxhib5GVlMhaMKJlKdcb1IlKzYKkjz4ozm98tEyHHEbv590QZZpgdQbOIz56dIFptxRAyQuV7fuOzv"
export const resetPasswordTokenIdentifier = "sapp-trad-pro-dashrSyeh5RwFAjPaDXGHLaPx7RGXIkLop3yEfmITCtMUU58Ag7MxbX2jwCIuvVK9zZxmq4Afgnttjk5fFxLfywwzU9xulDFxdGRZC8T2frVUpG5IfUbHwcOVvtFDTHw9O5tSZCDwbf"
export const resetPasswordUserIdentifier = "sapp-trad-pro-dashXkuMdMgXAuETPUZS5lQDu5PZaIwwpVx7JSZBSYvX36UPMVy0RsaAvvEDbXFftbvHMdWgszYogbyFby0Bb6U6MAg7Mx01Rm0y0r5Dz54WAervRJtYcOSXMleJxj8fuHQC"
export const locale = "sapp-trad-pro-dashzFk3JLwQj6MdFMbOw48XlojG1YvLmohRR2zAYgJTTO87PCg3tgQuJv7Khh2srJ0ZAg7MxtgqMDpl8IqhTEmuXeE4c4j5xkewCvMRjRuI4P5Y1jRe86PK5IdqCeX5RmQT"
export const agencyIdentifier = "sapp-trad-pro-dashzFk3JLwQj6cdbj5bbzu533yfepeuggjfmmqyefghn565d5g5trMdF5MbOw48XlojG1YvLmoh5R5R2zAYgJTTO8ue5rueuvehvsghapaopdj57khfbddjRuI4P5Y1jRe86PK5IdqCeX5Rhytas4"
export const languageIdentifier = "sapp-trad-pro-dashzA5DhudissdjhEH65JJVV5HT5jgDJDEF85zr56gerhgfng8d3dd5g5trMdF5MbOw48XlojG1YvLmoh5R5R2zAYgJTTO8ue5rueuvehvsghapaopdj57khfbddjRuI4P5Y1jRe86PK5IdqCeX5ervcf"
export const counterIdIdentifier = "sapp-trad-pro-dashzddissdjhEHjhsduysrgveriv pYGTYFVUY995ef864vetjhTYTY88z9e6r4revervbzevhjh96+HHUVGB85FRTVd47eBBI85NHYTDI966f5rverbbfvre85FRZDRVER8BERGEB45dfver7UJAEveuie5"

export const swalAnimation: any = {
  showClass: {
    popup: 'animate__animated animate__fadeInDown'
  },
  hideClass: {
    popup: 'animate__animated animate__fadeOutUp'
  }
}

export function formatDate(date: Date | string, dateFormat: string): string {
  const now = new Date();
  const diffInMinutes = (now.getTime() - new Date(date).getTime()) / (1000 * 60);
  const locale = dateFormat === 'fr' ? fr : enUS;

  if (diffInMinutes < 1) {
    return dateFormat === 'fr' ? 'à l\'instant' : 'just now';
  } else if (diffInMinutes < 15) {
    return dateFormat === 'fr' ? `${Math.floor(diffInMinutes)} min` : `${Math.floor(diffInMinutes)} min`;
  } else {
    return format(new Date(date), 'dd/MM/yyyy HH:mm', { locale });
  }
}

export function formatDateList(date: Date | string, dateFormat: string): string {
  const now = new Date();
  const diffInMinutes = (now.getTime() - new Date(date).getTime()) / (1000 * 60);
  const locale = dateFormat === 'fr' ? fr : enUS;

  if (diffInMinutes < 60) {
    return format(new Date(date), 'HH:mm', { locale });
  } else if (diffInMinutes < 48 * 60) {
    return dateFormat === 'fr' ? 'hier' : 'yesterday';
  } else {
    return format(new Date(date), 'dd/MM/yyyy', { locale });
  }
}

